import React, { Component } from "react";
import MyNavbar from "../../components/Navbar/MyNavbar";

//import ClientRegistration from "../../components/client/ClientRegistration/ClientRegistration";
import ClientRegistrationForOtherSoftware from "../../components/client/ClientRegistration/ClientRegistrationForOtherSoftware";

export default class ClientRegistrationPageForOtherSoftware extends Component {
  render() {
    return (
      <div>
        <MyNavbar />
        <ClientRegistrationForOtherSoftware/>
      </div>
    );
  }
}